module.exports = __webpack_public_path__ + "img/Botswana.37f3a988.gif";